var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "etowerHeaderPage disFlex",
      class: { postnord: _vm.brand === "postnord" },
    },
    [
      _c("div", { staticClass: "mainCont" }, [
        _c(
          "div",
          { staticClass: "leftCont" },
          [
            _c(
              "a",
              {
                staticClass: "goHome",
                attrs: { href: _vm.homeUrl, rel: "noopener noreferrer" },
              },
              [_vm._v(_vm._s(_vm.$t("spww.home")))]
            ),
            _vm._v(" "),
            _vm._l(_vm.menuList, function (parent) {
              return _c(
                "el-dropdown",
                {
                  key: parent.moduleUUID,
                  attrs: { index: parent.moduleUUID, placement: "bottom" },
                  on: {
                    "visible-change": function ($event) {
                      parent.isShowBottom = !parent.isShowBottom
                    },
                    command: _vm.handleSelectMenu,
                  },
                },
                [
                  _c("span", { staticClass: "menu-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.language === "en"
                            ? parent.titleEn
                            : parent.titleCn
                        ) +
                        "\n          "
                    ),
                    parent.isShowBottom
                      ? _c("i", { staticClass: "el-icon-caret-bottom" })
                      : _c("i", { staticClass: "el-icon-caret-top" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "div",
                        { staticClass: "custom-popper" },
                        _vm._l(parent.children, function (child) {
                          return _c(
                            "el-dropdown-item",
                            {
                              key: child.moduleUUID,
                              attrs: {
                                command: {
                                  parentPath: parent.path,
                                  childPath: child.path,
                                  parentTitleEn: parent.titleEn,
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.language === "en"
                                    ? child.titleEn
                                    : child.titleCn
                                )
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.defaultMenuList, function (parent) {
              return _c(
                "el-dropdown",
                {
                  key: parent.moduleUUID,
                  attrs: { index: parent.moduleUUID, placement: "bottom" },
                  on: {
                    "visible-change": function ($event) {
                      parent.isShowBottom = !parent.isShowBottom
                    },
                    command: _vm.handleSelectDefaultMenu,
                  },
                },
                [
                  _c("span", { staticClass: "menu-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.language === "en" ? parent.title : parent.titleCn
                        ) +
                        "\n          "
                    ),
                    parent.isShowBottom
                      ? _c("i", { staticClass: "el-icon-caret-bottom" })
                      : _c("i", { staticClass: "el-icon-caret-top" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "div",
                        { staticClass: "custom-popper" },
                        _vm._l(parent.children, function (child) {
                          return _c(
                            "el-dropdown-item",
                            {
                              key: child.title,
                              attrs: { command: child.href },
                            },
                            [_vm._v(_vm._s(child.title))]
                          )
                        }),
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "rightCont" }, [
          _c(
            "div",
            { staticClass: "right-menu" },
            [
              _c("lang-select", {
                staticClass: "right-menu-item hover-effect",
              }),
              _vm._v(" "),
              !_vm.name
                ? _c(
                    "el-button",
                    {
                      staticClass: "login-btn",
                      attrs: { type: "text", size: "mini" },
                      on: { click: _vm.loginBtn },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.login")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              !!_vm.name
                ? _c(
                    "el-dropdown",
                    {
                      staticClass: "avatar-container",
                      attrs: { placement: "bottom", trigger: "click" },
                      on: {
                        command: _vm.handleCommand,
                        "visible-change": _vm.onVisibleChange,
                      },
                    },
                    [
                      _c("div", { staticClass: "avatar-wrapper" }, [
                        _vm._v(
                          "\n            " + _vm._s(_vm.name) + "\n            "
                        ),
                        _vm.isShowBottom
                          ? _c("i", { staticClass: "el-icon-caret-bottom" })
                          : _c("i", { staticClass: "el-icon-caret-top" }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        {
                          staticClass: "user-dropdown",
                          attrs: { slot: "dropdown" },
                          slot: "dropdown",
                        },
                        [
                          !_vm.disablePasswordLogin
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: "1" } },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.aggregatorIsSystemPwd
                                          ? _vm.$t("login.resetPassword")
                                          : _vm.$t("navbar.changePassword")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-item",
                            {
                              staticClass: "dropdown-logout",
                              attrs: { command: "2" },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("login.logout")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            title: _vm.$t("navbar.changePassword"),
            visible: _vm.isShowPasswordDialog,
            width: "450px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowPasswordDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "passwordForm",
              staticClass: "update-form",
              attrs: {
                model: _vm.passwordForm,
                rules: _vm.passwordFormRules,
                "label-width": _vm.$t("navbar.passwordLabelWidth"),
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("common.userEmail") } },
                [_vm._v("admin@amin.com")]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("navbar.newPassword"),
                    prop: "password",
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "95%" },
                    attrs: { size: "mini", placeholder: "", type: "password" },
                    on: {
                      input: function ($event) {
                        _vm.passwordForm.password =
                          _vm.passwordForm.password.trim()
                      },
                    },
                    model: {
                      value: _vm.passwordForm.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.passwordForm, "password", $$v)
                      },
                      expression: "passwordForm.password",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("navbar.confirmpassword"),
                    prop: "password2",
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "95%" },
                    attrs: { size: "mini", placeholder: "", type: "password" },
                    on: {
                      input: function ($event) {
                        _vm.passwordForm.password =
                          _vm.passwordForm.password.trim()
                      },
                    },
                    model: {
                      value: _vm.passwordForm.password2,
                      callback: function ($$v) {
                        _vm.$set(_vm.passwordForm, "password2", $$v)
                      },
                      expression: "passwordForm.password2",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "default", size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.isShowPasswordDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.savePassword },
                },
                [_vm._v(_vm._s(_vm.$t("save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }